module.exports = __webpack_public_path__ + "static/media/fortify.7de0f8a.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/ware-2018/fortify.mp3
// module id = WixL
// module chunks = 0